module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/order_off-9e1d0ea35350b36583264623ad074bc1.gif";